import { ɵɵgetCurrentView, ɵɵelementStart, ɵɵlistener, ɵɵrestoreView, ɵɵnextContext, ɵɵelementEnd, ɵɵtemplate, ɵɵadvance, ɵɵproperty, EventEmitter, ɵɵdefineComponent, ɵsetClassMetadata, Component, Input, Output, ɵɵelementContainerStart, ɵɵelement, ɵɵtext, ɵɵelementContainerEnd, ɵɵstyleProp, ɵɵsanitizeHtml, ɵɵpureFunction1, ɵɵclassMapInterpolate1, ɵɵclassProp, ɵɵclassMap, ɵɵtextInterpolate1, ɵɵattribute, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule } from '@angular/core';
import { NgIf, NgForOf, CommonModule } from '@angular/common';
import { LineLoadingComponent, PaginatorComponent, AkeelaCommonModule } from '@akeela/common';
import { NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

function OrderComponent_div_0_img_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "img", 5);
    ɵɵlistener("click", function OrderComponent_div_0_img_1_Template_img_click_0_listener() { ɵɵrestoreView(_r5); const ctx_r4 = ɵɵnextContext(2); return ctx_r4.applyFilter({ identifier: ctx_r4.configuration.identifier, movement: "DESC" }); });
    ɵɵelementEnd();
} }
function OrderComponent_div_0_img_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "img", 6);
    ɵɵlistener("click", function OrderComponent_div_0_img_2_Template_img_click_0_listener() { ɵɵrestoreView(_r7); const ctx_r6 = ɵɵnextContext(2); return ctx_r6.applyFilter({ identifier: ctx_r6.configuration.identifier, movement: "ASC" }); });
    ɵɵelementEnd();
} }
function OrderComponent_div_0_img_3_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "img", 7);
    ɵɵlistener("click", function OrderComponent_div_0_img_3_Template_img_click_0_listener() { ɵɵrestoreView(_r9); const ctx_r8 = ɵɵnextContext(2); return ctx_r8.applyFilter({ identifier: ctx_r8.configuration.identifier, movement: "DESC" }); });
    ɵɵelementEnd();
} }
function OrderComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 1);
    ɵɵtemplate(1, OrderComponent_div_0_img_1_Template, 1, 0, "img", 2);
    ɵɵtemplate(2, OrderComponent_div_0_img_2_Template, 1, 0, "img", 3);
    ɵɵtemplate(3, OrderComponent_div_0_img_3_Template, 1, 0, "img", 4);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.configuration.identifier !== ctx_r0.active.identifier);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.configuration.identifier === ctx_r0.active.identifier && ctx_r0.active.movement === "DESC");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.configuration.identifier === ctx_r0.active.identifier && ctx_r0.active.movement === "ASC");
} }
class OrderComponent {
    constructor() {
        this.response = new EventEmitter();
    }
    set current(value) {
        this.active = value;
    }
    ngOnInit() { }
    applyFilter(event) {
        this.response.emit({
            identifier: event.identifier,
            movement: event.movement
        });
    }
}
/** @nocollapse */ OrderComponent.ɵfac = function OrderComponent_Factory(t) { return new (t || OrderComponent)(); };
/** @nocollapse */ OrderComponent.ɵcmp = ɵɵdefineComponent({ type: OrderComponent, selectors: [["akeela-order"]], inputs: { configuration: "configuration", current: "current" }, outputs: { response: "response" }, decls: 1, vars: 1, consts: [["class", "active-cursor", "style", " float: right;", 4, "ngIf"], [1, "active-cursor", 2, "float", "right"], ["src", "./assets/public/images/sort_both.png", 3, "click", 4, "ngIf"], ["src", "./assets/public/images/sort_asc.png", 3, "click", 4, "ngIf"], ["src", "./assets/public/images/sort_desc.png", 3, "click", 4, "ngIf"], ["src", "./assets/public/images/sort_both.png", 3, "click"], ["src", "./assets/public/images/sort_asc.png", 3, "click"], ["src", "./assets/public/images/sort_desc.png", 3, "click"]], template: function OrderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, OrderComponent_div_0_Template, 4, 3, "div", 0);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.active);
    } }, directives: [NgIf], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(OrderComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-order',
                templateUrl: './order.component.html',
                styleUrls: ['./order.component.css']
            }]
    }], function () { return []; }, { configuration: [{
            type: Input
        }], current: [{
            type: Input
        }], response: [{
            type: Output
        }] }); })();

function TableStickyComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 6);
    ɵɵelement(2, "hr");
    ɵɵelement(3, "br");
    ɵɵtext(4, " NO HAY INFORMACI\u00D3N PARA MOSTRAR ");
    ɵɵelement(5, "br");
    ɵɵelement(6, "br");
    ɵɵelement(7, "hr");
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} }
function TableStickyComponent_akeela_line_loading_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "akeela-line-loading");
} }
function TableStickyComponent_table_5_ng_container_2_ng_container_2_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 11);
} if (rf & 2) {
    const column_r8 = ɵɵnextContext().$implicit;
    ɵɵstyleProp("min-width", column_r8.minWidth, "px")("max-width", column_r8.maxWidth, "px");
    ɵɵproperty("innerHTML", column_r8.html, ɵɵsanitizeHtml);
} }
const _c0 = function (a0) { return { identifier: a0 }; };
function TableStickyComponent_table_5_ng_container_2_ng_container_2_akeela_order_4_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "akeela-order", 12);
    ɵɵlistener("response", function TableStickyComponent_table_5_ng_container_2_ng_container_2_akeela_order_4_Template_akeela_order_response_0_listener($event) { ɵɵrestoreView(_r13); const ctx_r12 = ɵɵnextContext(4); return ctx_r12.response_order($event); });
    ɵɵelementEnd();
} if (rf & 2) {
    const column_r8 = ɵɵnextContext().$implicit;
    const ctx_r10 = ɵɵnextContext(3);
    ɵɵproperty("configuration", ɵɵpureFunction1(2, _c0, column_r8.attr_order))("current", ctx_r10.order);
} }
function TableStickyComponent_table_5_ng_container_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "td");
    ɵɵelementStart(2, "div", 8);
    ɵɵtemplate(3, TableStickyComponent_table_5_ng_container_2_ng_container_2_div_3_Template, 1, 5, "div", 9);
    ɵɵtemplate(4, TableStickyComponent_table_5_ng_container_2_ng_container_2_akeela_order_4_Template, 1, 4, "akeela-order", 10);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r8 = ctx.$implicit;
    const row_r6 = ɵɵnextContext().$implicit;
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("table-column-padding ", column_r8.cssCustom, "");
    ɵɵstyleProp("background-color", row_r6.backgroundColor ? row_r6.backgroundColor : row_r6.fixed !== null ? "rgba(255, 255, 255, 1)" : "rgba(255, 255, 255, 0.3)");
    ɵɵclassProp("b-l-s-r", column_r8.enableRightBorder)("b-l-s-l", column_r8.enableLeftBorder)("table-column-sticky-right", column_r8.fixed === "right")("table-column-sticky-left", column_r8.fixed === "left")("text-center", column_r8.alignContent === "center")("text-right", column_r8.alignContent === "right")("text-left", column_r8.alignContent === "left");
    ɵɵadvance(2);
    ɵɵproperty("ngIf", column_r8.html !== "");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", column_r8.attr_order);
} }
function TableStickyComponent_table_5_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "tr");
    ɵɵtemplate(2, TableStickyComponent_table_5_ng_container_2_ng_container_2_Template, 5, 21, "ng-container", 7);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const row_r6 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵclassMap(row_r6.cssCustom ? row_r6.cssCustom : "");
    ɵɵstyleProp("background-color", row_r6.backgroundColor ? row_r6.backgroundColor : "rgba(255, 255, 255, 0.3)");
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", row_r6.columns);
} }
function TableStickyComponent_table_5_ng_container_4_ng_container_1_ng_container_2_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 15);
} if (rf & 2) {
    const column_r21 = ɵɵnextContext(2).$implicit;
    ɵɵproperty("innerHTML", column_r21.html, ɵɵsanitizeHtml);
} }
function TableStickyComponent_table_5_ng_container_4_ng_container_1_ng_container_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, TableStickyComponent_table_5_ng_container_4_ng_container_1_ng_container_2_ng_container_2_div_1_Template, 1, 1, "div", 14);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r21 = ɵɵnextContext().$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !column_r21.dropdown);
} }
function TableStickyComponent_table_5_ng_container_4_ng_container_1_ng_container_2_ng_container_3_ng_container_6_hr_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "hr", 23);
} }
function TableStickyComponent_table_5_ng_container_4_ng_container_1_ng_container_2_ng_container_3_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r32 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, TableStickyComponent_table_5_ng_container_4_ng_container_1_ng_container_2_ng_container_3_ng_container_6_hr_1_Template, 1, 0, "hr", 21);
    ɵɵelementStart(2, "a", 22);
    ɵɵlistener("click", function TableStickyComponent_table_5_ng_container_4_ng_container_1_ng_container_2_ng_container_3_ng_container_6_Template_a_click_2_listener() { ɵɵrestoreView(_r32); const lst_r28 = ctx.$implicit; const ctx_r31 = ɵɵnextContext(6); return ctx_r31.response_action({ obj: lst_r28.obj, action: lst_r28.obj.option }); });
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const lst_r28 = ctx.$implicit;
    const i_elem_r29 = ctx.index;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", i_elem_r29 !== 0);
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" ", lst_r28.value, " ");
} }
function TableStickyComponent_table_5_ng_container_4_ng_container_1_ng_container_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 16);
    ɵɵelement(2, "div", 17);
    ɵɵelementStart(3, "div", 18);
    ɵɵelementStart(4, "a", 19);
    ɵɵelement(5, "i", 20);
    ɵɵelementEnd();
    ɵɵtemplate(6, TableStickyComponent_table_5_ng_container_4_ng_container_1_ng_container_2_ng_container_3_ng_container_6_Template, 4, 2, "ng-container", 7);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r21 = ɵɵnextContext().$implicit;
    const i_stf_r19 = ɵɵnextContext().index;
    ɵɵadvance(2);
    ɵɵproperty("innerHTML", column_r21.dropdown.icon, ɵɵsanitizeHtml)("title", column_r21.dropdown.title)("id", "dropdown-" + column_r21.dropdown.identifier + "-" + i_stf_r19);
    ɵɵadvance(1);
    ɵɵattribute("aria-labelledby", "dropdown-" + column_r21.dropdown.identifier + "-" + i_stf_r19);
    ɵɵadvance(3);
    ɵɵproperty("ngForOf", column_r21.dropdown.list);
} }
function TableStickyComponent_table_5_ng_container_4_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r37 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "td", 13);
    ɵɵlistener("click", function TableStickyComponent_table_5_ng_container_4_ng_container_1_ng_container_2_Template_td_click_1_listener() { ɵɵrestoreView(_r37); const column_r21 = ctx.$implicit; const row_r17 = ɵɵnextContext().$implicit; const ctx_r35 = ɵɵnextContext(3); return ctx_r35.click_column(column_r21, row_r17); });
    ɵɵtemplate(2, TableStickyComponent_table_5_ng_container_4_ng_container_1_ng_container_2_ng_container_2_Template, 2, 1, "ng-container", 3);
    ɵɵtemplate(3, TableStickyComponent_table_5_ng_container_4_ng_container_1_ng_container_2_ng_container_3_Template, 7, 5, "ng-container", 3);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r21 = ctx.$implicit;
    const row_r17 = ɵɵnextContext().$implicit;
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("table-column-padding ", column_r21.cssCustom, "");
    ɵɵstyleProp("background-color", row_r17.enabled ? row_r17.backgroundColor ? row_r17.backgroundColor : row_r17.fixed !== null ? "rgba(255, 255, 255, 1)" : "rgba(255, 255, 255, 0.3)" : false);
    ɵɵclassProp("table-column-sticky-right", column_r21.fixed === "right")("table-column-sticky-left", column_r21.fixed === "left")("text-center", column_r21.alignContent === "center")("text-right", column_r21.alignContent === "right")("text-left", column_r21.alignContent === "left")("row-disable", !row_r17.enabled)("b-l-s-r", column_r21.enableRightBorder)("b-l-s-l", column_r21.enableLeftBorder);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !column_r21.dropdown);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", column_r21.dropdown);
} }
function TableStickyComponent_table_5_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "tr");
    ɵɵtemplate(2, TableStickyComponent_table_5_ng_container_4_ng_container_1_ng_container_2_Template, 4, 23, "ng-container", 7);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const row_r17 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("table-column-border-top ", row_r17.cssCustom, "");
    ɵɵstyleProp("background-color", row_r17.enabled ? row_r17.backgroundColor ? row_r17.backgroundColor : "rgba(255, 255, 255, 0.3)" : "rgba(255, 255, 255, 0.3)");
    ɵɵclassProp("active-cursor", row_r17.enabled)("row-disable", !row_r17.enabled);
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", row_r17.columns);
} }
function TableStickyComponent_table_5_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, TableStickyComponent_table_5_ng_container_4_ng_container_1_Template, 3, 10, "ng-container", 7);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ctx_r5.config.body.rows);
} }
function TableStickyComponent_table_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "table");
    ɵɵelementStart(1, "thead");
    ɵɵtemplate(2, TableStickyComponent_table_5_ng_container_2_Template, 3, 6, "ng-container", 7);
    ɵɵelementEnd();
    ɵɵelementStart(3, "tbody");
    ɵɵtemplate(4, TableStickyComponent_table_5_ng_container_4_Template, 2, 1, "ng-container", 3);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵclassMapInterpolate1("table ", ctx_r2.config.cssCustom, "");
    ɵɵadvance(1);
    ɵɵclassMap(ctx_r2.config.header.cssCustom);
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ctx_r2.config.header.rows);
    ɵɵadvance(1);
    ɵɵclassMap(ctx_r2.config == null ? null : ctx_r2.config.body == null ? null : ctx_r2.config.body.cssCustom);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r2.config.body.rows.length > 0);
} }
function TableStickyComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r40 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 24);
    ɵɵelement(1, "br");
    ɵɵelement(2, "br");
    ɵɵelement(3, "br");
    ɵɵelement(4, "br");
    ɵɵelement(5, "br");
    ɵɵelement(6, "br");
    ɵɵelementStart(7, "akeela-paginator", 25);
    ɵɵlistener("response", function TableStickyComponent_div_7_Template_akeela_paginator_response_7_listener($event) { ɵɵrestoreView(_r40); const ctx_r39 = ɵɵnextContext(); return ctx_r39.response_paginator($event); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext();
    ɵɵadvance(7);
    ɵɵproperty("paginator", ctx_r3.config_paginator);
} }
class TableStickyComponent {
    constructor() {
        this.response = new EventEmitter();
        this.loading_table = false;
        this.config_paginator = null;
    }
    set loading(value) {
        this.loading_table = value;
    }
    set paginator(value) {
        this.config_paginator = value;
    }
    set configuration(value) {
        this.config = value;
    }
    ngOnInit() { }
    open(response) {
        if (response.enabled) {
            this.response.emit({
                action: 'open',
                object: response
            });
        }
    }
    response_order(order) {
        this.order = order;
        this.response.emit({
            action: 'order',
            object: this.order
        });
    }
    response_action(object) {
        this.response.emit({
            action: 'action',
            object: object
        });
    }
    response_paginator(object) {
        this.response.emit({
            action: 'paginator',
            object: object
        });
    }
    click_column(column, row) {
        if (!column.dropdown && !column.click) {
            this.open(row);
        }
        else if (column.click) {
            this.response_action({
                obj: row,
                action: column.click
            });
        }
        else {
            return false;
        }
    }
}
/** @nocollapse */ TableStickyComponent.ɵfac = function TableStickyComponent_Factory(t) { return new (t || TableStickyComponent)(); };
/** @nocollapse */ TableStickyComponent.ɵcmp = ɵɵdefineComponent({ type: TableStickyComponent, selectors: [["akeela-table"]], inputs: { order: "order", loading: "loading", paginator: "paginator", configuration: "configuration" }, outputs: { response: "response" }, decls: 8, vars: 4, consts: [[1, "w-100", "box"], [1, "table-container"], [1, "table-container-child"], [4, "ngIf"], [3, "class", 4, "ngIf"], ["class", "externo pt-2", 4, "ngIf"], [1, "w-100", "text-center"], [4, "ngFor", "ngForOf"], [2, "display", "inline-flex"], ["style", " float: left;", 3, "min-width", "max-width", "innerHTML", 4, "ngIf"], [3, "configuration", "current", "response", 4, "ngIf"], [2, "float", "left", 3, "innerHTML"], [3, "configuration", "current", "response"], [3, "click"], [3, "innerHTML", 4, "ngIf"], [3, "innerHTML"], ["ngbDropdown", "", 2, "z-index", "inherit 9 !important"], ["placement", "bottom-left", "ngbDropdownToggle", "", 2, "z-index", "1!important", 3, "innerHTML", "title", "id"], ["ngbDropdownMenu", "", 1, "p-2", 2, "min-width", "250px", "font-size", "0.8rem", "top", "21px", "z-index", "inherit 99999999 !important"], ["href", "javascript:void(0)", 1, "text-dark", "float-right"], ["aria-hidden", "true ", 1, "fa", "fa-times", "active-cursor"], ["class", "m-1", 4, "ngIf"], ["href", "javascript:void(0)", 1, "text-dark", 3, "click"], [1, "m-1"], [1, "externo", "pt-2"], [3, "paginator", "response"]], template: function TableStickyComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵtemplate(3, TableStickyComponent_ng_container_3_Template, 8, 0, "ng-container", 3);
        ɵɵtemplate(4, TableStickyComponent_akeela_line_loading_4_Template, 1, 0, "akeela-line-loading", 3);
        ɵɵtemplate(5, TableStickyComponent_table_5_Template, 5, 11, "table", 4);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(6, "div", 1);
        ɵɵtemplate(7, TableStickyComponent_div_7_Template, 8, 1, "div", 5);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(3);
        ɵɵproperty("ngIf", ctx.config.body.rows.length === 0);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.loading_table);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.config.body.rows.length > 0);
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.config_paginator);
    } }, directives: [NgIf, LineLoadingComponent, NgForOf, OrderComponent, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, PaginatorComponent], styles: ["[_nghost-%COMP%]{--ak-table-background-color:#fff;--ak-table-border-weight:1px;--ak-table-color-border:rgba(0,0,0,0.3);--ak-table-color-row-disabled:#a5a3a3;--ak-table-color-shame-max:rgba(187,179,179,0.3);--ak-table-color-shame-min:hsla(0,0%,100%,0.3);--ak-table-font-size:16px;--ak-table-padding:6px;--ak-table-width:100%}.table[_ngcontent-%COMP%]{border-collapse:collapse;font-size:var(--ak-table-font-size);width:var(--ak-table-width)}.table-container[_ngcontent-%COMP%]{align-items:center;display:flex;flex-direction:column;height:100%;justify-content:center}.table-container-child[_ngcontent-%COMP%]{overflow:auto;width:100%}.table-column-padding[_ngcontent-%COMP%]{padding:var(--ak-table-padding)}.table-column-sticky-left[_ngcontent-%COMP%]{position:-webkit-sticky;position:sticky;right:0}.table-column-sticky-right[_ngcontent-%COMP%]{left:0;position:-webkit-sticky;position:sticky}.table-column-border-top[_ngcontent-%COMP%]{border-top:var(--ak-table-border-weight) solid var(--ak-table-color-border)}.b-l-s-r[_ngcontent-%COMP%]{background-image:linear-gradient(270deg,var(--ak-table-color-shame-max) 0,var(--ak-table-color-shame-min));background-position:100% 0}.b-l-s-l[_ngcontent-%COMP%], .b-l-s-r[_ngcontent-%COMP%]{background-repeat:no-repeat;background-size:20px 100%}.b-l-s-l[_ngcontent-%COMP%]{background-image:linear-gradient(90deg,var(--ak-table-color-shame-max) 0,var(--ak-table-color-shame-min))}.row-disable[_ngcontent-%COMP%]{background-color:var(--ak-table-background-color);color:var(--ak-table-color-row-disabled);cursor:default}.externo[_ngcontent-%COMP%]{align-items:center;display:flex;justify-content:center}.pt-2[_ngcontent-%COMP%]{padding-top:24px}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(TableStickyComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-table',
                templateUrl: './table-sticky.component.html',
                styleUrls: ['./table-sticky.component.css']
            }]
    }], function () { return []; }, { order: [{
            type: Input
        }], loading: [{
            type: Input
        }], paginator: [{
            type: Input
        }], configuration: [{
            type: Input
        }], response: [{
            type: Output
        }] }); })();

class AkTableModule {
}
/** @nocollapse */ AkTableModule.ɵmod = ɵɵdefineNgModule({ type: AkTableModule });
/** @nocollapse */ AkTableModule.ɵinj = ɵɵdefineInjector({ factory: function AkTableModule_Factory(t) { return new (t || AkTableModule)(); }, imports: [[
            CommonModule,
            BsDropdownModule.forRoot(),
            NgbModule,
            AkeelaCommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(AkTableModule, { declarations: [OrderComponent, TableStickyComponent], imports: [CommonModule, BsDropdownModule, NgbModule,
        AkeelaCommonModule], exports: [OrderComponent, TableStickyComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkTableModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    BsDropdownModule.forRoot(),
                    NgbModule,
                    AkeelaCommonModule
                ],
                declarations: [OrderComponent, TableStickyComponent],
                exports: [OrderComponent, TableStickyComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of ak-table
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AkTableModule, OrderComponent, TableStickyComponent };
//# sourceMappingURL=akeela-ak-table.js.map
